
export enum TipoNegociacaoPontoExtraEnum {
  Conquistado = 'Conquistado',
  Negociado = 'Negociado',
}
